import Head from "next/head";
import Link from "next/link";

export default function IndexPage() {
  return (
    <div className="container d-flex flex-grow-1">
      <Head>
        <title>คลังความรู้ | {process.env.appName}</title>
        <meta
          name="description"
          content="คลังความรู้ในการเขียนบทความ SEO ภาษาไทย"
        />
        <meta
          name="og:title"
          content={`คลังความรู้ | ${process.env.appName}`}
        />
        <meta
          name="og:description"
          content="คลังความรู้ในการเขียนบทความ SEO ภาษาไทย"
        />
      </Head>

      <main className="w-100">
        <div className="mt-2 mb-1 card">
          <div className="px-4 py-2 my-2">
            <h1 className="h4">คลังความรู้</h1>
            <ul
              className="mt-2 mb-2 list-group list-group-flush"
              id="info-accordion"
            >
              <li className="list-group-item border-top">
                <strong>
                  <Link href="/contents/seo-content-length-best-practice">
                    บทความ SEO ควรมีความยาวเท่าไหร่
                    จึงจะติดอันดับการค้นหาอันดับต้นๆ ได้
                  </Link>
                </strong>
              </li>
              <li className="list-group-item">
                <strong>
                  <Link href="/contents/thai-word-count-tools">
                    อยากนับคำภาษาไทยทำได้ยังไงบ้าง รวมเครื่องมือนับคำ
                    ตัวช่วยที่ทำให้งานของนักเขียนง่ายขึ้น
                  </Link>
                </strong>
              </li>
            </ul>
          </div>
        </div>
      </main>
    </div>
  );
}
